import React, { useContext } from 'react';
import { Col, Form, Row } from 'antd';
import UAFLegalPersonForm from './FormComponents/UAFLegalPersonForm';
import UAFLegalBackgroundForm from './FormComponents/UAFLegalBackgroundForm';
import UAFTopManagementForm from './FormComponents/UafLegalStructureForm';
import tokens from '../../../../../../../../utils/tokens';
import './styles.less';
import { EnrollmentFormContext } from '../../../../../../../../providers/EnrollmentFormContextProvider';
import form from '../../../../../../../../utils/form';

const LegalPersonForm = () => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);

  const gutter = tokens.forms.horizontalGutterInPx;

  const initialValues = {
    legalStructurePeople: [{}],
  };

  return (
    <Row className="declaringPersonForm">
      <Col span={24}>
        <Form
          form={enrollmentForm}
          layout="vertical"
          initialValues={initialValues}
          validateMessages={form.validateMessages}
        >
          <UAFLegalPersonForm gutter={gutter} />
          <UAFLegalBackgroundForm gutter={gutter} />
          <UAFTopManagementForm gutter={gutter} />
        </Form>
      </Col>
    </Row>
  );
};

export default LegalPersonForm;
